import { render, staticRenderFns } from "./MobileErrorPage.vue?vue&type=template&id=3e86d9b6&scoped=true"
import script from "./MobileErrorPage.vue?vue&type=script&lang=js"
export * from "./MobileErrorPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e86d9b6",
  null
  
)

export default component.exports